import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

/**
 * Hook that loads all reference/lookup data needed by transactional modals.
 * Pass `cnpj` to also load escola-scoped data (contas, favorecidos).
 */
function useReferenceData(token, cnpj, refreshKey = 0) {
  const [programas, setProgramas] = useState([]);
  const [acoes, setAcoes] = useState([]);
  const [contas, setContas] = useState([]);
  const [favorecidos, setFavorecidos] = useState([]);
  const [naturezas, setNaturezas] = useState([]);
  const [tiposBens, setTiposBens] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [agencias, setAgencias] = useState([]);

  useEffect(() => {
    if (!token) return;
    const h = { Authorization: `Bearer ${token}` };
    axios.get(`${API_BASE_URL.PROGRAMA}/all`, { headers: h }).then(r => setProgramas(r.data)).catch(() => {});
    axios.get(`${API_BASE_URL.ACAO}/all`, { headers: h }).then(r => setAcoes(r.data)).catch(() => {});
    axios.get(`${API_BASE_URL.NATUREZA}/all`, { headers: h }).then(r => setNaturezas(r.data)).catch(() => {});
    axios.get(`${API_BASE_URL.TIPO_BEM}/all`, { headers: h }).then(r => setTiposBens(r.data)).catch(() => {});
    axios.get(`${API_BASE_URL.BANCO}/all`, { headers: h }).then(r => setBancos(r.data)).catch(() => {});
    if (cnpj) {
      axios.get(`${API_BASE_URL.AGENCIA}/findByEscola`, { params: { idEscola: cnpj }, headers: h }).then(r => setAgencias(r.data)).catch(() => {});
      axios.get(`${API_BASE_URL.CONTA}/findByEscola`, { params: { idEscola: cnpj }, headers: h }).then(r => setContas(r.data)).catch(() => {});
      axios.get(`${API_BASE_URL.FAVORECIDO}/findByEscola`, { params: { idEscola: cnpj }, headers: h }).then(r => setFavorecidos(r.data)).catch(() => {});
    }
  }, [token, cnpj, refreshKey]);

  return { programas, acoes, contas, favorecidos, naturezas, tiposBens, bancos, agencias };
}

export default useReferenceData;
